var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHintLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21.470703 8.9863281 A 1.50015 1.50015 0 0 0 20.439453 9.4394531 L 6.4394531 23.439453 A 1.50015 1.50015 0 0 0 6.4394531 25.560547 L 20.439453 39.560547 A 1.50015 1.50015 0 1 0 22.560547 37.439453 L 11.121094 26 L 40.5 26 A 1.50015 1.50015 0 1 0 40.5 23 L 11.121094 23 L 22.560547 11.560547 A 1.50015 1.50015 0 0 0 21.470703 8.9863281 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintLeft);
export default __webpack_public_path__ + "static/media/hint-left.c6d66a05c6ca26b4c8ecb84c4dc6695f.svg";
export { ForwardRef as ReactComponent };